import * as React from 'react'

import { IProps } from './IProps'
import { Container } from './styles'

export const Alert: React.FC<IProps> = ({ children, severity, ...rest }) => {
  return (
    <Container severity={severity} {...rest}>
      {children}
    </Container>
  )
}
